import { apiClient } from './apiClient'

// Generic GET
export async function fetchData<T = any>(path: string): Promise<T> {
  const response = await apiClient.get<T>(path)
  return response.data
}

// Generic POST
export async function postData<T = any, P = any>(
  path: string,
  data: P
): Promise<T> {
  const response = await apiClient.post<T>(path, data)
  return response.data
}

// Generic PATCH
export async function patchData<T = any, P = any>(
  path: string,
  data: P
): Promise<T> {
  const response = await apiClient.patch<T>(path, data)
  return response.data
}

// Generic DELETE
export async function deleteData<T = any>(path: string): Promise<T> {
  const response = await apiClient.delete<T>(path)
  return response.data
}
